module.exports = __webpack_public_path__ + "static/media/nopic.0d019992.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/nopic.jpg
// module id = 282
// module chunks = 0